import React from 'react';
import { Users, Home, Shield, Map, Mountain, Utensils } from 'lucide-react';
import FeatureCard from './FeatureCard.tsx';
import ImageSection from './ImageSection.tsx';
import { Helmet } from 'react-helmet';
export default function About({t}) {
  const features = [
    {
      icon: <Users className="w-8 h-8 text-[--c-main]" />,
      title: t.feature1Title,
      description: t.feature1Description,
    },
    {
      icon: <Home className="w-8 h-8 text-[--c-main]" />,
      title: t.feature2Title,
      description: t.feature2Description,
    },
    {
      icon: <Shield className="w-8 h-8 text-[--c-main]" />,
      title: t.feature3Title,
      description: t.feature3Description
    },
    {
      icon: <Map className="w-8 h-8 text-[--c-main]" />,
      title: t.feature4Title,
      description: t.feature4Description    
    },
    {
      icon: <Mountain className="w-8 h-8 text-[--c-main]" />,
      title: t.feature5Title,
      description: t.feature5Description,    
    },
    {
      icon: <Utensils className="w-8 h-8 text-[--c-main]" />,
      title: t.feature6Title,
      description: t.feature6Description 
    }
  ];
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[--c-light]/1 py-16 pt-[150px]">
          <Helmet>
        <title>{t.welcomeTitle} | About Us | [Your Website Name]</title>
        <meta
          name="description"
          content={t.welcomeDescription} // Use a concise summary of your business
        />
        <meta
          name="keywords"
          content="o nama, nas tim, nase vrednosti, misija, vizija, apartmani, smestaj, izdavanje apartmana, bovansko jezero, bovan"
        />
      </Helmet>
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-[--c-dark] mb-6">{t.welcomeTitle}</h1>
          <p className="text-main text-2xl max-w-2xl mx-auto leading-relaxed">
            {t.welcomeDescription}
          </p>
        </div>

        <ImageSection
          imageUrl={require('../../Styling/bovanskoAbout.jpg')}
          title={t.section1Title}
          description={t.section1Description}
        />

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {features.slice(0,3).map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>

        <ImageSection
          imageUrl={require('../../Styling/bovanHome.JPG')}
          title={t.section2Title}
          description={t.section2Description}
          reverse
        />
       <div className="grid md:grid-cols-3 gap-8 mb-16">
          {features.slice(3,6).map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
        <div className="bg-[--c-main]/5 rounded-lg p-12 text-center mt-16">
          <h2 className="text-4xl font-bold text-[--c-dark] mb-6">{t.excellenceTitle}</h2>
          <p className="text-main text-2xl max-w-3xl mx-auto leading-relaxed">
            {t.excellenceDescription}
          </p>
        </div>
      </div>
    </div>
  );
}